import styled from 'styled-components';

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  border: none;
  display: block;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  word-break: break-word;
  white-space: nowrap;
`;

export const StyledTh = styled.th`
  word-break: break-word;
  white-space: normal;
  min-width: 10rem;
  overflow-wrap: break-word;
  hyphens: auto;
  word-wrap: break-word;
  white-space: pre-wrap !important;
`;

export const StyledTd = styled.td`
  word-break: break-word;
  word-wrap: break-word;
  white-space: pre-wrap !important;

  @media (max-width: 64rem) {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    margin-bottom: -1px;
    position: relative;
    padding-left: 50%;

    &:before {
      content: attr(data-label);
      position: absolute;
      left: 10px;
      width: calc(50% - 20px);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: bold;
      padding-right: 10px;
    }

    span {
      display: block;
      padding-left: 10px;
    }
  }
`;

export const StyledTr = styled.tr`
  min-width: 250px;
  flex: 1 1;
  @media (max-width: 64rem) {
    margin-bottom: 10px;
    border-radius: 5px;
    padding: 10px;
  }
`;

export const StyledThead = styled.thead<{ show: boolean }>`
  display: ${({ show }) => (!show ? 'none' : 'table-header-group')};
`;
